import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SellerMenu.css';

const SellerMenu = () => {
  const location = useLocation();

  const menuItems = [
    {
      path: '/account',
      label: 'Profilo'
    },
    {
      path: '/seller-products',
      label: 'Prodotti'
    },
    {
      path: '/seller-analytics',
      label: 'Analytics'
    },
    {
      path: '/seller-integration',
      label: 'Integrazione'
    },
    {
      path: '/merchant',
      label: 'Trasferisci Merchant'
    },
    {
      path: '/google-ads-campaigns',
      label: 'Google Ads'
    },
    {
      path: '/billing',
      label: 'Pagamenti e Fatturazione'
    },
    {
      path: '/shipping-rates',
      label: 'Spedizione'
    },
    {
      path: '/seller-terms-of-service',
      label: 'Termini di Servizio'
    }
  ];

  return (
    <nav className="seller-menu">
      <div className="seller-menu-container">
        <div className="seller-menu-items">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`seller-menu-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="seller-menu-label">{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default SellerMenu; 